import React from "react";
import InPersonAppointment from "../../../components/Patient/InPersonAppointment/InPersonAppointment";

const VideoAppointmentMain = () => {
  return <InPersonAppointment />;
};

export default VideoAppointmentMain;
